import React, { useRef, useState } from 'react';
import { Button } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';

export default function DeclareWinButton({ onConfirm, disabled }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const confirmed = useRef(false);
    const cancel = () => setOpen(false);
    return <>
        <Button aria-label={t('gameRoom.declareWinning')} title={t('gameRoom.declareWinning')}
            startIcon={<EmojiEventsIcon />} className="app-btn declare-win-button" variant="contained"
            color="success" disabled={disabled} sx={{ textTransform: 'none' }}
            onClick={() => { confirmed.current = false; setOpen(true); }}>
            <span className="action-label">{t('gameRoom.declareWinning')}</span>
        </Button>
        <ConfirmDialog open={open} onCancel={cancel} onHide={cancel} fullWidth
            title={t('gameRoom.declareWinConfirmation')} confirmText={t('gameRoom.declareWinConfirmText')}
            onConfirm={() => {
                cancel();
                if (!disabled && !confirmed.current) { confirmed.current = true; onConfirm(); }
            }} />
    </>;
}
